export default {
  name: 'modalUiMixin',
  methods: {
    closeModal() {
      this.$store.commit('openModal', [false]);
    },
  },
};
